<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="carBox">
            <div class="mainBody">
                <div class="searchBox">
                    <el-button type="primary" plain @click.native="addProject">添加</el-button>
                    <el-button type="primary"  @click="delAll">删除选中</el-button>
                </div>
                <div class="dataBox">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column type="selection" align="center" width="50"></el-table-column>
                        <el-table-column prop="org_name" label="项目名称" sortable="custom"></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" plain type="primary" @click="del(scope.$index, scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <ProjectList
                    width="800px"
                    :user_id="user_id"
                    title="分配项目"
                    :isshow="selectshow"
                    @selectProject="selectProject"
                    @on-close="closeSelectDialog">
                </ProjectList>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil";
import ProjectList from "./projectlist2";
import { allocationProject } from "@/api/user";

export default {
    name: "roleList",
    mixins: [listutil],
    components: { ProjectList },
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        user_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_user_id = this.user_id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '选择项目',
            menu_id: 1160,
            list_url: "/api/admin/userproject/list",
            search_Obj: {
                f_user_id: '',
            },
            del_Obj:{
                url:'/api/admin/userproject/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            showflag: false,
            selectshow: false,
        };
    },
    mounted() {},
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        addProject(){
            this.selectshow = true
        },
        closeSelectDialog(){
            this.selectshow = false
        },
        selectProject(org_ids){
            this.selectshow = false
            allocationProject(this.user_id, org_ids).then(res=>{
                if(res.code == 1){
                    this.$msgs("分配成功")
                    this.getListData();
                }else{
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>